<template>
  <div class="card mb-2">
    <div class="card-body">
      <p class="card-text" v-html="value" />
      <p class="card-text">
        <small class="text-muted mr-1">
          Created at Version: <strong>{{ versionNumber }}</strong>
        </small>
        <small class="text-muted mr-1">
          Created by: <strong>{{ name }}</strong>
        </small>
        <small class="text-muted">
          Created at: <strong>{{ version.updated_at | localDateTime }}</strong>
        </small>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    version: Object,
    type: String,
    state: Object,
  },

  computed: {
    value() {
      let value;

      switch (this.type) {
        case 'Choice':
          value = `Option ${this.version.value + 1}`;
          break;

        case 'Inline':
          value = this.generateInline();
          break;

        case 'ExpandableList':
          value = this.generateList();
          break;

        case 'ExpandableGrid':
          value = this.generateTable();
          break;

        default:
          value = this.version.value;
          break;
      }

      return value;
    },

    name() {
      if (!this.version.user) {
        if (!this.version.counter_party) {
          return 'Error evaluating user';
        }
        return this.version.counter_party.name;
      }

      return this.version.user.fullname;
    },

    versionNumber() {
      const operators = {
        even: (version) => version % 2 === 0,
        odd: (version) => version % 2 !== 0,
      };

      const operatorToUse = this.state.withCounterparty ? 'even' : 'odd';

      const majorVersion = Math.floor(this.version.version);

      if (operators[operatorToUse](majorVersion)) return `${Math.ceil(this.version.version)}.00`;

      return this.version.version;
    },
  },

  methods: {
    generateInline() {
      let value = '';
      Object.keys(this.version.value).map((i) => this.version.value[i].forEach((e) => {
        value += `${e}<br/>`;
      }));
      return value;
    },

    generateList() {
      let html = '';
      this.version.value.forEach((value) => {
        html = `${html}<p>${value}</p>`;
      });

      return html;
    },

    generateTable() {
      let html = '<table class="table">';

      this.version.value.forEach((row) => {
        html = `${html}<tr>`;
        row.forEach((value) => {
          html = `${html}<td>${value}</td>`;
        })
        html = `${html}</tr>`;
      });

      return `${html}</table>`;
    },
  },
};
</script>
